import styled, { css } from 'styled-components'

export const ChecklistTitle = styled.div`
  overflow-wrap: anywhere;
  word-break: break-word;
  hyphens: auto;
  white-space: normal;
`

export const ChecklistProgress = styled.div`
  display: flex;
  gap: 12px;
  align-items: center;
`

export const ChecklistProgressBar = styled.div`
  height: 4px;
  background-color: var(--t-checklist-progress-bar-task-detail-bg);
  position: relative;
  width: 100%;
  border-radius: 12px;

  &:after {
    content: '';
    position: absolute;
    height: 4px;
    min-width: 8px;
    transition: width 0.3s ease;
    ${({ bgColor }) => css`
      background-color: ${bgColor || 'var(--t-action-accent)'};
    `}

    border-radius: 12px;
    ${({ percent }) => css`
      width: ${percent || 0}%;
      max-width: 100%;
    `}
  }
`

export const ProgressCounter = styled.div`
  font-size: 12px;
  font-weight: 400;
  line-height: 1.2;
`
export const ChecklistItems = styled.div``

export const ChecklistItemWrap = styled.div`
  display: flex;
  font-size: 14px;
  font-weight: 400;
  line-height: 24px;
  color: var(--t-text-primary);
  padding: 8px 0 7px;
  border-bottom: 1px solid var(--t-checklist-item-wrapper-border);
  gap: 8px;
  min-width: 0;
  overflow-wrap: anywhere;
  word-break: break-word;

  &:first-child {
    padding-top: 0;
  }

  &:last-child {
    padding-bottom: 0;
    border-bottom: none;
  }

  span {
    margin: 0;
  }
`

export const CheckboxWrap = styled.label`
  padding-top: 4px;
`

export const CheclistItemText = styled.div`
  ${(p) =>
    p.isDone &&
    css`
      color: var(--t-checklist-input-done-text);
    `}
`

export const CheclistPoint = styled.span``

export const CheclistText = styled.span`
  ${(p) =>
    p.isDone &&
    css`
      text-decoration: line-through;
    `}
`

const defaultStyles = css`
  padding: 12px;
  font-size: 16px;
  font-weight: 600;
  color: var(--t-text-input);
  gap: 16px;
`

const templateStyles = css`
  padding: 0;
  font-size: 14px;
  font-weight: 400;
  color: var(--t-template-description-title-color);
  gap: 12px;
`

const checklistVariantStyles = {
  default: defaultStyles,
  template: templateStyles,
}

export const ChecklistWrap = styled.div`
  border-radius: 12px;
  background-color: var(--t-surface-2);
  display: flex;
  flex-direction: column;

  ${({ $variant }) => checklistVariantStyles[$variant] ?? defaultStyles}
`
